import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55154de7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-width w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "bg-primary text-color-white py-9" }
const _hoisted_5 = {
  scope: "col",
  style: {"border-right":"none"}
}
const _hoisted_6 = {
  scope: "col",
  class: "text-align-left"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { style: {"width":"55%"} }
const _hoisted_9 = { style: {"width":"45%","text-align":"right"} }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { style: {"width":"55%"} }
const _hoisted_12 = { style: {"width":"45%","text-align":"right"} }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_SwitchToggle = _resolveComponent("SwitchToggle")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", null, [
      _createVNode(_component_SimpleText, { "text-key": "calculation.methodselection.text.method" })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
      [_directive_dompurify_html, _ctx.getContentfulString('calculation.methodselection.text.method.description')]
    ]),
    _hoisted_2,
    _createElementVNode("table", {
      "aria-label": _ctx.getContentfulString('calculation.methodselection.text.method'),
      class: "table",
      style: {"max-width":"680px"}
    }, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_4, [
          _createElementVNode("th", _hoisted_5, [
            _createVNode(_component_SimpleText, { "text-key": "calculation.methodselection.text.method.table.emission-factor" })
          ]),
          _createElementVNode("th", _hoisted_6, [
            _createVNode(_component_SimpleText, { "text-key": "calculation.methodselection.text.method" })
          ])
        ])
      ]),
      (_ctx.results)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_8, [
                _createVNode(_component_SimpleText, { "text-key": "calculation.methodselection.text.method.choice-emission-factor-electricity" })
              ]),
              _createElementVNode("td", _hoisted_9, [
                (!_ctx.printMode)
                  ? (_openBlock(), _createBlock(_component_SwitchToggle, {
                      key: 0,
                      checked: _ctx.methodSelection,
                      "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.methodSelection) = $event)),
                      countryLocked: _ctx.calculation?.companyInformation?.country !== 'DK',
                      leftLabel: this?.electricityEnvironmentDeclarationTrue,
                      rightLabel: this?.electricityEnvironmentDeclarationFalse,
                      fieldId: "metodevalgId"
                    }, null, 8, ["checked", "countryLocked", "leftLabel", "rightLabel"]))
                  : _createCommentVNode("", true),
                (_ctx.printMode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.calculation.electricityEnvironmentDeclaration
                ? this?.electricityEnvironmentDeclarationTrue
                : this?.electricityEnvironmentDeclarationFalse), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_11, [
                _createVNode(_component_SimpleText, { "text-key": "calculation.methodselection.text.method.emission-factor-fly" })
              ]),
              _createElementVNode("td", _hoisted_12, [
                (!_ctx.printMode)
                  ? (_openBlock(), _createBlock(_component_SwitchToggle, {
                      key: 0,
                      checked: _ctx.methodSelectionRFI,
                      "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.methodSelectionRFI) = $event)),
                      leftLabel: this?.rfiTrue,
                      rightLabel: this?.rfiFalse,
                      fieldId: "metodevalgIdRFI"
                    }, null, 8, ["checked", "leftLabel", "rightLabel"]))
                  : _createCommentVNode("", true),
                (_ctx.printMode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.calculation.rfi
                  ? this?.rfiTrue
                  : this?.rfiFalse), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_3)
  ]))
}